import firebase from '../../assets/stacklogo/firebase.svg';

export default function Firebase(){
    return(
        <img src={firebase} alt="" srcset="" />
    )
}